<template>
  <!-- 精准客户审核 -->
  <div class="viewContainer">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao" />
      </div>
      <el-form class="findform">
        <el-form-item label="商家名称：" style="display:flex;width:30%">
          <el-input v-model="shopkey" placeholder="请输入商家店铺名称或个人商家手机号码" maxlength="30" style="width:90%;" />
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    <!-- 精准客户审核列表 -->
    <div class="main_container">
      <section class="model_section" style="display: flex;justify-content: space-between;">
        <div>
          <p class="model_top_title">精准客户审核</p>
        </div>
      </section>
      <div class="table_container">
        <el-table :data="xsjlList" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope"> <span>{{ scope.$index + 1 }}</span> </template>
          </el-table-column>
          <el-table-column label="商家名称" align="center">
            <template scope="scope">
              <span :title="scope.row.shopname"> {{ scope.row.shopname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商家手机号" align="center">
            <template scope="scope">
              <span :title="scope.row.shopphone"> {{ scope.row.shopphone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户隐私号" align="center">
            <template scope="scope">
              <span :title="scope.row.virtualnumber"> {{ scope.row.virtualnumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拨打时间" align="center">
            <template scope="scope">
              <span :title="scope.row.calltime"> {{ scope.row.calltime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户价格" align="center">
            <template scope="scope">
              <span :title="scope.row.price"> {{ scope.row.price }} 元</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">
              <span :title="scope.row.statusname"> {{ scope.row.statusname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="260">
            <template scope="scope">
              <span class="handle" @click="showAdd(scope.row)"> <i class="el-icon-view" /> 查看 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentChangeOne" :page-size="10" :total="totalOne"
          :current-page="pageIndexOne" style="float:right;margin: 10px 0;" />
      </div>
    </div>

    <!-- 抽屉详情 size="50%" -->
    <el-drawer :visible.sync="isSeePopup" :show-close=false>
      <template v-slot:title>
        <ul class="drawer_title">
          <li>订单详情</li>
        </ul>
      </template>
      <div class="drawer_div">
        <ul class="drawer_ul">
          <li>
            <span class="watch_first">商家名称：</span>
            <span>{{ formDetails.shopname }}</span>
          </li>
          <li>
            <span class="watch_first">用户隐私号：</span>
            <span>{{ formDetails.virtualnumber }}</span>
          </li>
          <li>
            <span class="watch_first">商家手机号：</span>
            <span>{{ formDetails.shopphone }}</span>
          </li>
          <li>
            <span class="watch_first">拨打时间：</span>
            <span>{{ formDetails.calltime }}</span>
          </li>
          <li>
            <span class="watch_first">客户价格：</span>
            <span>{{ formDetails.price }}元</span>
          </li>
          <li>
            <span class="watch_first">状态：</span>
            <span>{{ formDetails.status == 2 ? '待审核' : formDetails.status == 3 ? '审核通过':'审核不通过' }}</span>
          </li>
          <li v-if="formDetails.status != 1">
            <span class="watch_first">退款原因：</span>
            <span>{{ formDetails.reason }}</span>
          </li>
          <li v-if="formDetails.status == 3 || formDetails.status == 4">
            <span class="watch_first">审核原因：</span>
            <span>{{ formDetails.auditreason }}</span>
          </li>
          <li>
            <span class="watch_first">通话录音：</span>
            <audio :src="formDetails.rediourl" controls="controls" style="width: 90%;height: 35px;margin: 5px 0;" />
          </li>
        </ul>
        <div class="drawer_foot">
          <el-button type="danger" @click="cancelForm" v-if="formDetails.status!==2">关 闭</el-button>
          <el-button type="danger" @click="reviewFun(4, formDetails)" v-if="formDetails.status == 2">审核不通过</el-button>
          <el-button type="primary" @click="reviewFun(3, formDetails)" v-if="formDetails.status == 2">审核通过</el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { precisioncustomerlist, precisioncustomerDet, precisioncustomerAudit, } from "../../api/shopWindow";
export default {
  name: "PrecisionCustomerAudit", //精准客户审核 
  mixins: [alertTrends],
  data() {
    return {
      shopkey: '',   //输入关键字


      isSeePopup: false, //查看
      formDetails: [],//详情

      xsjlList: [],
      pageIndexOne: 1,
      totalOne: 0,


      recordurl: '', // 录音URL
      callrecords: [], // 录音列表
      api2cs: localStorage.api2cs,

    }
  },
  methods: {
    // 套餐包列表
    initOne() {
      let obj = {
        page: this.pageIndexOne, // 页码
        size: 10, // 条数
        key: this.shopkey,
      }
      precisioncustomerlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.xsjlList = data.resultObj.list;
          this.totalOne = data.resultObj.totalcount;
        } else {
          this.xsjlList = [];
          this.totalOne = 0
        }
      })
    },

    fnReset(){
      this.shopkey = '';
      this.pageIndexOne = 1;
      this.initOne()
    },
    // 分页
    currentChangeOne(val) {
      this.pageIndexOne = val;
      this.initOne()
    },

    // 查询
    onSubmit() {
      this.initOne()
    },

    showAdd(row, type) {
      this.isSeePopup = true;
      this.precisioncustomerDetFun(row.shopid, row.recordid);//获取详情
    },
    
    //获取详情
    precisioncustomerDetFun(shopid,recordid) {
      let obj = {
        shopid: shopid,
        recordid: recordid,
      }
      precisioncustomerDet(obj).then(data => {
        if (data.resultCode == 1) {
          this.formDetails = data.resultObj;
        } else {
          this.formDetails = [];
        }
      })
    },

    // 审核
    reviewFun(status, row) {
      this.$prompt('请输入审核原因(200字以内)', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\S.{0,199}$/,
        inputErrorMessage: '请输入审核原因，字数不能超过200字'
      }).then(({ value }) => {
        let obj = {
          shopid: row.shopid,
          status: status,
          recordid: row.recordid,
          reason: value
        }
        precisioncustomerAudit(obj).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功"
            });
            this.isSeePopup = false;
            this.initOne();
          }
        })

      }).catch(() => {

      });

    },

    cancelForm() {
      this.isSeePopup = false
    },

    

  },
  mounted() {
    this.initOne(); // 初始化查询列表
  },
  watch: {
    
  }
}
</script>
<style scoped>
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}

.drawer_title>li:first-child {
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}

.drawer_div {
  width: 96%;
  margin: 0 auto;
}

.drawer_ul:first-child {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 5px;
}

.drawer_ul>li {
  line-height: 40px;
  font-size: 16px;
}

.drawer_ul>li>span {
  font-size: 15px;
}

.drawer_ul>li>span>img {
  width: 66px;
  height: 66px;
  margin-left: 10px;
  margin-bottom: 10px;
}


/* 外层布局：并排显示多选框和输入区 */
.package-detail-layout {
  display: flex;
  align-items: flex-start;
  /* 垂直顶部对齐，避免多选框和输入区高度差异导致错位 */
  gap: 24px;
  /* 多选框与输入区的间距 */
}

/* 输入区：垂直排列每个输入项 */
.package-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* 输入项之间的间距 */
}

/* 单个输入项：名称与输入框横向对齐 */
.input-row {
  display: flex;
  align-items: center;
  gap: 12px;
  /* 名称与输入框的间距 */
}

/* 产品名称：固定宽度 + 右对齐，确保输入框整齐 */
.product-name {
  min-width: 80px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// PrecisionCustomerAudit.vue?4380d75d